import { useEffect } from "react";

/**
 * ScrollToTop - resets scroll on every route change. React Router v7 doesn't
 * scroll to top automatically.
 */
export default function ScrollToTop({ pathname }) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
